// @flow

import type {MarkdocRenderTag} from 'markdoc/types';
import {isMarkdocAstTag} from 'docs/util';

export const findMarkdocTag = (
  tags: Array<MarkdocRenderTag | string>,
  predicate: (tag: MarkdocRenderTag) => boolean,
): ?MarkdocRenderTag => {
  for (const tag of tags) {
    if (isMarkdocAstTag(tag) && typeof tag !== 'string' && predicate(tag)) {
      return tag;
    }
  }
};
